<template>
  <div class="home">
    <div class="header">
      <el-row :gutter="20">
        <el-col :span="12">
          <div>
            <invoice-type v-model:code="listQuery.fplxdm"></invoice-type>
            <el-button :loading="loading" type="primary" size="mini" @click="search" style="margin-left:4px">查询</el-button>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="right">
            <el-button @click="invoiceApply" size="mini" type="primary" plain>发票领购</el-button>
            <el-button @click="noInvoice()" size="mini" type="danger" plain>空白票作废</el-button>
            <el-button @click="getList()" :loading="loading" size="mini" type="primary" plain>刷新</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-table ref="singleTable" :data="tableData" highlight-current-row border @current-change="handleCurrentChange" style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}" size="mini">
        <el-table-column type="selection" width="55" align="center"> </el-table-column>
        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
        <!-- <el-table-column property="fpdm" label="发票代码" width="120" align="center"></el-table-column> -->
        <el-table-column label="发票类型" width="160" align="center">
          <template v-slot="scope">
            <span>{{ $fplx(scope.row.fplxdm) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="qshm" label="发票起始号码" width="120" align="center"></el-table-column>
        <el-table-column property="zzhm" label="发票终止号码" align="center"> </el-table-column>
        <el-table-column property="fpfs" label="发票份数" align="center"> </el-table-column>
        <el-table-column property="syfs" label="剩余份数" width="120" align="center"></el-table-column>
        <el-table-column property="lgrq" label="领购日期" width="120" align="center"></el-table-column>
        <el-table-column property="lgry" label="领购人员" align="center"> </el-table-column>
      <!-- <el-table-column fixed="right" label="操作" width="100">
        <template #default="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
          <el-button @click="delCorp(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column> -->
      </el-table>
    </div>
    <!-- 弹框 空白作废 -->
    <el-dialog v-model="dialogFormVisible" width="30%" title="空白票作废申请">
      <el-form size="mini" label-position="right" label-width="100px">
        <el-form-item label="发票类型">
          <invoice-type @success="getZfInvoice" v-model:code="tempZf.fplxdm"></invoice-type>
        </el-form-item>
        <el-form-item label="发票代码">
          <el-input v-model="tempZf.fpdm"></el-input>
        </el-form-item>
        <el-form-item label="发票号码">
          <el-input v-model="tempZf.fphm"></el-input>
        </el-form-item>
        <el-form-item label="作废人">
          <el-input v-model="tempZf.zfr"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="mini" type="primary" @click="zfConfirm()">确定 </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import router from '@/router/index.js'
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { invoiceInventory, notOpenInvoice } from "@/api/apply";
import { cancelInvoice } from "@/api/open";

export default {
  name: 'InvoiceInventory',
  created () {
    this.getList()
  },
  data(){
    return {
      dialogFormVisible: false,
      tempZf: {
        type: "0",
      },
      loading: false,
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: '',
      },
      tableData: [],
      
    }
  },
  methods:{
    //空白作废
    zfConfirm(){
      if(!this.tempZf.fplxdm){
        this.$qzfMessage("请选择发票类型", 1)
        return
      }
      if(!this.tempZf.zfr){
        this.$qzfMessage("请填写作废人", 1)
        return
      }
      this.tempZf.comId = this.$store.getters['user/comInfo'].id*1
      cancelInvoice(this.tempZf).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("作废成功")
          this.dialogFormVisible = false
        }
      })
    },
    //获取作废信息
    getZfInvoice(fplxdm){
      let param = {
        "fplxdm": fplxdm,
        comId: this.$store.getters['user/comInfo'].id*1,
      }
      notOpenInvoice(param).then(res=>{
        if(res.data.msg == "success"){
          this.tempZf.fpdm = res.data.data.fpdm
          this.tempZf.fphm = res.data.data.fphm
        }
      })
    },
    noInvoice(){
      this.tempZf = {type: "0",}
      this.dialogFormVisible = true
    },
    search(){
      if(this.listQuery.fplxdm == ""){
        this.$qzfMessage("请选择发票类型", 1)
        return
      }
      this.getList()
    },
    //获取列表
    getList(){
      this.loading = true
      invoiceInventory(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }else{
          this.tableData = []
        }
      })
    },
    invoiceApply(){
      router.push( "/apply/invoiceApply");
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.header{
  margin-bottom: 10px;
  .right{
    float: right;
  }
  .input-search{
    width: 180px;
    margin-right: 5px;
  }
}
.home{
  padding: 10px;
}
</style>